import React from 'react';
import ReactDOM from 'react-dom/client';
import { AccountInfo, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import App from './Components/App';
import { msalInstance } from './Auth/AuthProvider';

async function bootstrap() {
  // Initialize MSAL first
  await msalInstance.initialize();

  // Complete redirect processing
  const redirectResult = await msalInstance.handleRedirectPromise();

  if (redirectResult?.account) {
    msalInstance.setActiveAccount(redirectResult.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  msalInstance.addEventCallback((event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event.payload &&
      'account' in event.payload
    ) {
      msalInstance.setActiveAccount(event.payload.account as AccountInfo);
    }
  });

  // Only now render the app
  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );
}

bootstrap();
